import { useIntl } from '@zenbusiness/application-commons-intl';
import CardHeader from '@zenbusiness/zui/CardHeader';

import * as Styled from './ConfirmationContent.styles';

export const LOCALIZED_TEXT = {
  title: 'dashboard.carousel.card.smsOptIn.confirmation.title',
  subtitle: 'dashboard.carousel.card.smsOptIn.confirmation.subTitle'
};

function ConfirmationContent() {
  const { formatMessage: fm } = useIntl();

  return (
    <Styled.CardContent spacing={2}>
      <CardHeader
        title={fm({ id: LOCALIZED_TEXT.title })}
        subtitle={fm({ id: LOCALIZED_TEXT.subtitle })}
      />
    </Styled.CardContent>
  );
}

export default ConfirmationContent;
